import "./App.css";
import React from "react";
import Questionary from "./Questionary";
import Transformations from "./Transformations";
import Plans from "./Plans";
import About from "./About";
import Footer from "./Footer";

function App() {
  return (
    <div className="App">
      <header>
        <a href="/">
          AS <br />
          <span>coaching</span>
        </a>
      </header>
      <article>
        <h1>Online Coaching</h1>
        <Questionary />
      </article>

      <Transformations />
      <About />
      <Plans />
      <Footer />
      <footer>
        Powered by{" "}
        <a href="https://www.linkedin.com/in/gabriela-agostinho24/">
          Gabriela Agostinho
        </a>{" "}
      </footer>
    </div>
  );
}

export default App;
